// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"close-button_CloseButton__zDGXw"};